import { useState } from "react";
import { MiniQuestionnaireData, initialMiniQuestionnaireData } from "../types/miniQuestionnaire";

export const useMiniQuestionnaire = () => {
  const [data, setData] = useState<MiniQuestionnaireData>(initialMiniQuestionnaireData);

  const updateData = (field: keyof MiniQuestionnaireData, value: string) => {
    setData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const updateDepistages = (depistage: string, checked: boolean) => {
    setData(prev => {
      let newDepistages;
      if (checked) {
        newDepistages = [...prev.depistages_effectues, depistage];
      } else {
        newDepistages = prev.depistages_effectues.filter(d => d !== depistage);
      }
      return {
        ...prev,
        depistages_effectues: newDepistages
      };
    });
  };

  const resetData = () => {
    setData(initialMiniQuestionnaireData);
  };

  return {
    data,
    updateData,
    updateDepistages,
    resetData
  };
};
